import React from 'react'
import agent from '../agent'
import { connect } from 'react-redux'
import { store } from '../store'
import { push } from 'react-router-redux'
import ListErrors from './ListErrors'
import {

} from '../constants/actionTypes'
import { BASE_COIN_SYMBOL } from '../constants/config'
import { Link } from 'react-router-dom'
const mapStateToProps = state => ({

})

const mapDispatchToProps = dispatch => ({

})

class RegisterSuccess extends React.Component {
    constructor() {
        super()
        this.state = {

        }

    }
    componentWillMount() {
    }

    componentWillUnmount() {
    }

    render() {

        return (
            <div id="focus">
                <div id="main">
                    <div id="main-wrap">
                        <div id="focus-wrap">
                            <h2>Thank you for your registration. We will be in touch regarding enabling your merchant account.</h2>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterSuccess)
